var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "timetable" } },
    [
      !_vm.hideTitle
        ? _c(
            "h2",
            {
              staticClass: "h1 text-center timetable-primary-color-color",
              attrs: { id: "rooster" },
            },
            [
              !_vm.activitySelected.length || _vm.activitySelected.length > 1
                ? _c("span", [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("timetable.name")) +
                        "\n        "
                    ),
                  ])
                : _c(
                    "span",
                    [
                      _c("i18next", {
                        attrs: {
                          translation: _vm.$t("timetable.timetable_for", {
                            name: _vm.activitySelected[0].name,
                          }),
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "name",
                              fn: function () {
                                return [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.activitySelected[0].name?.toLowerCase()
                                      )
                                    ),
                                  ]),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          2352984020
                        ),
                      }),
                    ],
                    1
                  ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "row d-flex justify-content-between" }, [
        _c("div", { staticClass: "col-12 col-lg-6 col-xl-5" }, [
          _c(
            "div",
            { staticClass: "form-group d-flex warehouse-select" },
            [
              !_vm.warehouseMultiple || _vm.hideWarehouseFilter
                ? _c(
                    "label",
                    {
                      staticClass: "mb-0 me-2",
                      attrs: { for: "warehouses" },
                      on: { click: _vm.toggleWarehouseSelect },
                    },
                    [
                      _c("strong", [
                        _vm._v(_vm._s(_vm.$t("timetable.rooster_of")) + ":"),
                      ]),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.warehousesSelected?.[0]?.name ||
                              "(onbekende locatie)"
                          )
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.hideWarehouseFilter
                ? _c("CustomMultiSelect", {
                    ref: "warehouseSelect",
                    staticClass: "w-100",
                    attrs: {
                      options: _vm.warehouses,
                      multiple: _vm.warehouseMultiple,
                      name: "warehouses",
                      "max-visible-tags": 2,
                      "show-reset-button": _vm.isWarehouseSelectionNotDefault,
                      placeholder: _vm.$t(
                        _vm.warehouseMultiple
                          ? "timetable.select_warehouses"
                          : "timetable.select_warehouse"
                      ),
                      "search-placeholder": _vm.$t(
                        _vm.warehouseMultiple
                          ? "timetable.search_warehouses"
                          : "timetable.search_warehouse"
                      ),
                      "track-by": "id",
                      label: "name",
                    },
                    on: {
                      clear: function ($event) {
                        _vm.warehousesSelected = _vm.getDefaultWarehouse()
                      },
                    },
                    model: {
                      value: _vm.warehousesSelected,
                      callback: function ($$v) {
                        _vm.warehousesSelected = $$v
                      },
                      expression: "warehousesSelected",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-12 col-lg-6 col-xl-4 end" },
          [
            !_vm._hideActivityFilter
              ? _c("CustomMultiSelect", {
                  staticClass: "w-100",
                  attrs: {
                    options: _vm.activities,
                    multiple: _vm.activityMultiple,
                    "max-visible-tags": 2,
                    placeholder: _vm.$t(
                      _vm.activityMultiple
                        ? "timetable.select_activities"
                        : "timetable.select_activity"
                    ),
                    "search-placeholder": _vm.$t(
                      _vm.activityMultiple
                        ? "timetable.search_activities"
                        : "timetable.search_activity"
                    ),
                    "track-by": "id",
                    label: "name",
                  },
                  model: {
                    value: _vm.activitySelected,
                    callback: function ($$v) {
                      _vm.activitySelected = $$v
                    },
                    expression: "activitySelected",
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row d-block d-xxl-none" }, [
        _c("div", { staticClass: "col-12 d-block d-xl-none mt-3" }, [
          _c(
            "h4",
            { staticClass: "text-center timetable-primary-color-color" },
            [
              _vm._v(
                "\n                " + _vm._s(_vm.weekTitle) + "\n            "
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "col-12 d-flex justify-content-between align-items-center mt-3 mb-3",
          },
          [
            _c("div", { staticClass: "button-container" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-sm btn-tt-nav",
                  attrs: { disabled: _vm.isPrevWeekDisabled },
                  on: { click: _vm.prevWeek },
                },
                [
                  _c("i", { staticClass: "fas fa-chevron-left" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "d-none d-md-inline" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("timetable.previous_week")) +
                        "\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "d-inline d-md-none" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("timetable.previous")) +
                        "\n                    "
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-sm btn-tt-nav ms-2",
                  attrs: { disabled: _vm.isCurrentWeek },
                  on: { click: _vm.goToCurrentWeek },
                },
                [
                  _c("span", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("timetable.this_week")) +
                        "\n                    "
                    ),
                  ]),
                ]
              ),
            ]),
            _vm._v(" "),
            _c(
              "h4",
              {
                staticClass:
                  "text-center timetable-primary-color-color mb-0 d-none d-xl-block",
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.weekTitle) +
                    "\n            "
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "button-container text-right" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-sm btn-tt-nav",
                  on: { click: _vm.nextWeek },
                },
                [
                  _c("span", { staticClass: "d-none d-md-inline" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("timetable.next_week")) +
                        "\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "d-inline d-md-none" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("timetable.next")) +
                        "\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("i", { staticClass: "fas fa-chevron-right" }),
                ]
              ),
            ]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          {
            staticClass:
              "col-12 d-flex justify-content-between align-items-center mt-3 mb-3",
          },
          [
            _c("div", { staticClass: "button-container" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-tt-nav d-none d-xxl-inline",
                  attrs: { disabled: _vm.isPrevWeekDisabled },
                  on: { click: _vm.prevWeek },
                },
                [
                  _c("i", { staticClass: "fas fa-chevron-left" }),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("timetable.previous_week")) +
                        "\n                    "
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-tt-nav d-none d-xxl-inline ms-2",
                  attrs: { disabled: _vm.isCurrentWeek },
                  on: { click: _vm.goToCurrentWeek },
                },
                [
                  _c("span", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("timetable.this_week")) +
                        "\n                    "
                    ),
                  ]),
                ]
              ),
            ]),
            _vm._v(" "),
            _c(
              "h4",
              {
                staticClass:
                  "text-center timetable-primary-color-color d-none d-xxl-block",
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.weekTitle) +
                    "\n            "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "d-block d-xxl-none week-navigation flex-grow-1 mx-2",
              },
              [
                _c(
                  "div",
                  { staticClass: "week-days" },
                  _vm._l(_vm.navigationDays, function (day, index) {
                    return _c(
                      "button",
                      {
                        key: index,
                        staticClass: "day-button",
                        class: {
                          active: _vm.isActiveDayButton(day.date),
                          clicked:
                            _vm.clickedDay ===
                            _vm.format(day.date, "yyyy-MM-dd"),
                          today:
                            _vm.format(day.date, "yyyy-MM-dd") ===
                            _vm.format(_vm.today, "yyyy-MM-dd"),
                        },
                        on: {
                          click: function ($event) {
                            return _vm.navigateToDay(day.date)
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "day-name" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm.format(day.date, "eeeeee", {
                                  locale:
                                    _vm.locales[_vm.i18next.language] ||
                                    _vm.locales["en-GB"],
                                })
                              ) +
                              "\n                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "day-number" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.format(day.date, "dd")) +
                              "\n                        "
                          ),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "button-container text-right" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-tt-nav d-none d-xxl-inline",
                  on: { click: _vm.nextWeek },
                },
                [
                  _c("span", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("timetable.next_week")) +
                        "\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("i", { staticClass: "fas fa-chevron-right" }),
                ]
              ),
            ]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12" }, [
          _c(
            "div",
            {
              staticClass: "week-carousel",
              class: { "is-loading": _vm.isLoading },
            },
            [
              _c(
                "div",
                { ref: "weekCarousel", staticClass: "owl-carousel" },
                _vm._l(_vm.daysToShow, function (day, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "day-slide",
                      class: {
                        "is-today":
                          _vm.format(day.date, "yyyy-MM-dd") ===
                          _vm.format(_vm.today, "yyyy-MM-dd"),
                      },
                    },
                    [
                      _c("div", { staticClass: "day-header" }, [
                        _c("div", { staticClass: "day-number" }, [
                          _vm._v(
                            "\n                                " +
                              _vm._s(day.date.getDate()) +
                              "\n                            "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "day-name" }, [
                          _vm._v(
                            "\n                                " +
                              _vm._s(day.name) +
                              "\n                            "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "day-content" },
                        [
                          !_vm.isLoading && day.items.length
                            ? [
                                _c(
                                  "transition-group",
                                  {
                                    staticClass: "moments-list",
                                    attrs: { name: "list", tag: "ul" },
                                  },
                                  _vm._l(
                                    _vm.getVisibleItems(day.items, day.date),
                                    function (moment, momentIndex) {
                                      return _c(
                                        "li",
                                        {
                                          key: `${_vm.format(
                                            day.date,
                                            "dd-MM"
                                          )}-${_vm.format(
                                            new Date(moment.start),
                                            "HH:mm"
                                          )}-${
                                            moment.extendedProps.ActivityID
                                          }-${
                                            moment.extendedProps.WarehouseID
                                          }-${
                                            moment.extendedProps.LocationID
                                          }-${momentIndex}-${
                                            (day.items || 0).length
                                          }`,
                                          class: {
                                            "ending-soon": moment.ending,
                                            "has-child":
                                              moment.children?.length &&
                                              moment.children.length === 1,
                                            "has-children":
                                              moment.children?.length &&
                                              moment.children.length > 1,
                                            "exception-block":
                                              moment.extendedProps.Type ===
                                              "CLOSURE",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "card-content" },
                                            [
                                              _c(
                                                "h6",
                                                {
                                                  staticClass:
                                                    "timetable-primary-color",
                                                },
                                                [
                                                  moment.extendedProps
                                                    .ActivityURL
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "d-flex justify-content-between align-items-center w-100",
                                                        },
                                                        [
                                                          moment.extendedProps
                                                            .ActivityURL !==
                                                          _vm.currentUrl
                                                            ? _c(
                                                                "a",
                                                                {
                                                                  attrs: {
                                                                    href: moment
                                                                      .extendedProps
                                                                      .ActivityURL,
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                                                        " +
                                                                      _vm._s(
                                                                        moment
                                                                          .extendedProps
                                                                          .Name
                                                                      ) +
                                                                      "\n                                                    "
                                                                  ),
                                                                ]
                                                              )
                                                            : _c("span", [
                                                                _vm._v(
                                                                  "\n                                                        " +
                                                                    _vm._s(
                                                                      moment
                                                                        .extendedProps
                                                                        .Name
                                                                    ) +
                                                                    "\n                                                    "
                                                                ),
                                                              ]),
                                                          _vm._v(" "),
                                                          moment.extendedProps
                                                            .ActivityURL !==
                                                          _vm.currentUrl
                                                            ? _c(
                                                                "a",
                                                                {
                                                                  staticClass:
                                                                    "btn btn-outline-info btn-sm btn-circle ml-2",
                                                                  attrs: {
                                                                    href: moment
                                                                      .extendedProps
                                                                      .ActivityURL,
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "FontAwesomeIcon",
                                                                    {
                                                                      attrs: {
                                                                        icon: _vm
                                                                          .icons
                                                                          .faInfo,
                                                                        "fixed-width":
                                                                          "",
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      )
                                                    : moment.extendedProps
                                                        .AvailabilityException
                                                        .Name
                                                    ? _c("span", [
                                                        _vm._v(
                                                          "\n                                                    " +
                                                            _vm._s(
                                                              _vm.$t("Let op")
                                                            ) +
                                                            ": " +
                                                            _vm._s(
                                                              moment
                                                                .extendedProps
                                                                .AvailabilityException
                                                                .Name
                                                            ) +
                                                            "\n                                                "
                                                        ),
                                                      ])
                                                    : _c("span", [
                                                        _vm._v(
                                                          "\n                                                    " +
                                                            _vm._s(
                                                              moment
                                                                .extendedProps
                                                                .Name
                                                            ) +
                                                            "\n                                                "
                                                        ),
                                                      ]),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "content-wrap" },
                                                [
                                                  _c("time", [
                                                    _vm._v(
                                                      "\n                                                    " +
                                                        _vm._s(
                                                          _vm
                                                            .format(
                                                              new Date(
                                                                moment.start
                                                              ),
                                                              "eeeeee. HH:mm",
                                                              {
                                                                locale:
                                                                  _vm.locales[
                                                                    _vm.i18next
                                                                      .language
                                                                  ] ||
                                                                  _vm.locales[
                                                                    "en-GB"
                                                                  ],
                                                                weekStartsOn: 1,
                                                              }
                                                            )
                                                            .replace(
                                                              /^\w/,
                                                              (c) =>
                                                                c.toUpperCase()
                                                            )
                                                        ) +
                                                        " - " +
                                                        _vm._s(
                                                          _vm.format(
                                                            new Date(
                                                              moment.end
                                                            ),
                                                            "HH:mm"
                                                          )
                                                        ) +
                                                        "\n                                                "
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "p",
                                                    {
                                                      class: {
                                                        "mb-0":
                                                          moment.extendedProps
                                                            .occupation,
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "show",
                                                              rawName: "v-show",
                                                              value:
                                                                _vm
                                                                  .warehousesSelected
                                                                  .length !== 1,
                                                              expression:
                                                                "warehousesSelected.length !== 1",
                                                            },
                                                          ],
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              moment
                                                                .extendedProps[
                                                                "Warehouse.Name"
                                                              ]
                                                            ) + ":"
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(
                                                        "\n                                                    " +
                                                          _vm._s(
                                                            moment
                                                              .extendedProps[
                                                              "Location.Name"
                                                            ]
                                                          ) +
                                                          "\n                                                "
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  moment.extendedProps
                                                    .occupation &&
                                                  !moment.ending &&
                                                  !moment.children?.length
                                                    ? _c("p", [
                                                        _c("small", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "common.occupation"
                                                              )
                                                            ) +
                                                              ": " +
                                                              _vm._s(
                                                                moment
                                                                  .extendedProps
                                                                  .occupation
                                                              )
                                                          ),
                                                        ]),
                                                      ])
                                                    : _vm._e(),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex justify-content-end",
                                                },
                                                [
                                                  _vm.getMomentStatus(moment)
                                                    ? [
                                                        _c(
                                                          "b-button",
                                                          {
                                                            staticClass:
                                                              "btn btn-xs ml-1",
                                                            style:
                                                              !_vm.getMomentStatus(
                                                                moment
                                                              ).canReserve
                                                                ? "pointer-events: none;"
                                                                : "",
                                                            attrs: {
                                                              variant:
                                                                _vm.getMomentStatus(
                                                                  moment
                                                                ).variant,
                                                              disabled:
                                                                !_vm.getMomentStatus(
                                                                  moment
                                                                ).canReserve,
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                                return _vm.openReservationModal(
                                                                  moment
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                                        " +
                                                                _vm._s(
                                                                  _vm.getMomentStatus(
                                                                    moment
                                                                  ).text
                                                                ) +
                                                                "\n                                                        "
                                                            ),
                                                            _vm.getMomentStatus(
                                                              moment
                                                            ).showQueueCount &&
                                                            moment.extendedProps
                                                              .QueueQuantity > 0
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "badge badge-pill badge-light",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                                                            " +
                                                                        _vm._s(
                                                                          moment
                                                                            .extendedProps
                                                                            .QueueQuantity
                                                                        ) +
                                                                        "\n                                                        "
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        ),
                                                      ]
                                                    : moment.children?.length &&
                                                      !moment.ending
                                                    ? [
                                                        _c(
                                                          "b-button",
                                                          {
                                                            staticClass:
                                                              "btn btn-xs ml-1",
                                                            attrs: {
                                                              variant:
                                                                "outline-primary",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                                return _vm.openReservationModal(
                                                                  moment
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                                        " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "timetable.blocks"
                                                                  )
                                                                ) +
                                                                "\n                                                    "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    : _vm._e(),
                                                ],
                                                2
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                ),
                                _vm._v(" "),
                                _vm.hasMoreItems(day.items)
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "show-more-wrapper",
                                        class: {
                                          expanded:
                                            _vm.expandedDays[
                                              _vm.format(day.date, "yyyy-MM-dd")
                                            ],
                                        },
                                      },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-link btn-show-more",
                                            on: {
                                              click: function ($event) {
                                                return _vm.toggleDayExpand(
                                                  day.date
                                                )
                                              },
                                            },
                                          },
                                          [
                                            !_vm.expandedDays[
                                              _vm.format(day.date, "yyyy-MM-dd")
                                            ]
                                              ? [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "common.show_more",
                                                          {
                                                            count:
                                                              day.items.length -
                                                              _vm.maxPerDay,
                                                          }
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("i", {
                                                    staticClass:
                                                      "fas fa-chevron-down",
                                                  }),
                                                ]
                                              : [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "common.show_less"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("i", {
                                                    staticClass:
                                                      "fas fa-chevron-up",
                                                  }),
                                                ],
                                          ],
                                          2
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            : !_vm.isLoading && !day.items.length
                            ? _c("div", { staticClass: "no-items-block" }, [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(_vm.$t("timetable.no_results")) +
                                    "\n                            "
                                ),
                              ])
                            : _c(
                                "ul",
                                { staticClass: "moments-list" },
                                _vm._l(
                                  Math.floor(Math.random() * 5) + 1,
                                  function (n) {
                                    return _c("li", {
                                      key: `loading-${n}`,
                                      staticClass:
                                        "b-skeleton b-skeleton-text b-skeleton-animate-wave",
                                      staticStyle: {
                                        width: "100%",
                                        height: "5rem",
                                      },
                                    })
                                  }
                                ),
                                0
                              ),
                        ],
                        2
                      ),
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c("div", { staticClass: "touch-drag-icon" }, [
                _c("div", { staticClass: "d-block d-xxl-none" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "45.999",
                        height: "28.325",
                        viewBox: "0 0 45.999 28.325",
                      },
                    },
                    [
                      _c(
                        "g",
                        {
                          attrs: {
                            id: "Group_259",
                            "data-name": "Group 259",
                            transform: "translate(-173 -2353.837)",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              id: "hand-back-point-up-solid",
                              d: "M22.639,0a2.212,2.212,0,0,0-2.213,2.213V17.7a.885.885,0,0,1-1.77,0V14.622c-.111.077-.216.166-.321.249l-1.062.885A3.544,3.544,0,0,0,16,18.478v2.1a7.074,7.074,0,0,0,2.55,5.438l.3.249a8.845,8.845,0,0,0,5.665,2.052l6.534.006a7.081,7.081,0,0,0,7.081-7.081V15.933A2.656,2.656,0,0,0,33.7,13.958a2.658,2.658,0,0,0-4.426-1.77,2.658,2.658,0,0,0-4.42-1.776v-8.2A2.212,2.212,0,0,0,22.639,0Z",
                              transform: "translate(169 2353.837)",
                            },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              id: "Icon_fa-solid-arrow-right-long",
                              "data-name": "Icon fa-solid-arrow-right-long",
                              d: "M17.67,13.167a1.127,1.127,0,0,0,0-1.593l-4.5-4.5a1.126,1.126,0,1,0-1.593,1.593l2.58,2.58H1.125a1.125,1.125,0,0,0,0,2.25H14.157l-2.58,2.58A1.126,1.126,0,0,0,13.17,17.67l4.5-4.5Z",
                              transform: "translate(201 2361.255)",
                            },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              id: "Icon_fa-solid-arrow-right-long-2",
                              "data-name": "Icon fa-solid-arrow-right-long",
                              d: "M17.67,13.167a1.127,1.127,0,0,0,0-1.593l-4.5-4.5a1.126,1.126,0,1,0-1.593,1.593l2.58,2.58H1.125a1.125,1.125,0,0,0,0,2.25H14.157l-2.58,2.58A1.126,1.126,0,0,0,13.17,17.67l4.5-4.5Z",
                              transform: "translate(190.999 2386) rotate(180)",
                            },
                          }),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "subtext" }, [
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm.$t("timetable.touch_drag_hint")) +
                        "\n                        "
                    ),
                  ]),
                ]),
              ]),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.selectedItem
        ? _c("ReservationModal", {
            ref: "reservationModal",
            attrs: {
              item: _vm.selectedItem,
              "csrf-token": _vm.csrfToken,
              "has-siblings": _vm.selectedStackedItem,
            },
            on: {
              "show-siblings": _vm.showSiblings,
              close: _vm.handleModalClose,
              reserved: _vm.handleReservationComplete,
              "show-added-to-cart": function ($event) {
                _vm.showAddedToCartModal = true
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.selectedStackedItem
        ? _c("StackedMomentsModal", {
            ref: "stackedMomentsModal",
            attrs: { "main-item": _vm.selectedStackedItem },
            on: {
              close: function ($event) {
                _vm.selectedStackedItem = null
              },
              "select-moment": _vm.handleStackedMomentSelect,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showAddedToCartModal
        ? _c("add-to-cart-modal", { on: { close: _vm.closeAddedToCartModal } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }